import { renderTranslatedMessage } from '../../utils/redux-form-helper';
import messages from './messages';
import { handleHudRecalcSuccess, handleHudRecalcFailure } from './actions';

/**
 * Consumed by Socket context to register listeners for the async HUD Minimum
 * Rent recalculation. The backend echoes correlationId/propertyId on the
 * notification envelope so the saga can target the right in-progress toast.
 */
const viewPropertyEvents = (dispatch, socket) => {
  /**
   * Guard against duplicate registration. If connect() runs more than once on
   * the same socket instance, re-registering without removing the previous
   * listener would handle a single backend notification twice (two green
   * toasts). Removing any existing listener for the event first guarantees the
   * handler is attached exactly once.
   */
  socket.off('hud.minRent.success');
  socket.on('hud.minRent.success', (message) => {
    const { payload } = message ?? {};
    dispatch(
      handleHudRecalcSuccess({
        payload,
        title: renderTranslatedMessage(messages.success),
        message: renderTranslatedMessage(messages.successBody),
      }),
    );
  });

  socket.off('hud.minRent.error');
  socket.on('hud.minRent.error', (message) => {
    const { payload } = message ?? {};
    dispatch(
      handleHudRecalcFailure({
        payload,
        title: renderTranslatedMessage(messages.error),
        message: renderTranslatedMessage(messages.errorBody),
      }),
    );
  });
};

export default viewPropertyEvents;
